module.exports = __webpack_public_path__ + "img/nature-14.b7c416b6.jpg";